import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cls } from '@/utils/cls';

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      className={cls(
        'shrink-0 bg-zinc-200 data-[orientation=horizontal]:h-px data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-px dark:bg-zinc-800',
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
